import React from 'react';
import {useNavigate} from 'react-router-dom';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {
    AssignmentOutlined,
    DescriptionOutlined,
    ListAltOutlined,
    MailOutlined,
    SchoolOutlined
} from '@material-ui/icons';
import PageWrapper from '../../shared/pagewrapper/PageWrapper.js';
import PageTitle from '../../shared/pagetitle/PageTitle.js';
import Separator from '../../shared/separator/Separator.js';
import useCheckModule from '../../../hooks/useCheckModule.js';
import useInitialPath from '../../../hooks/useInitialPath.js';
import {textButton} from '../../../utils/styles.js';

/* Caminhos relativos a /administrativo. */
const ATALHOS = [
    {label: 'Inscrições', path: 'inscricoes', modulo: 'INSCRICAO', descricao: 'Consultar e editar as inscrições dos candidatos', Icon: AssignmentOutlined},
    {label: 'Processos de Seleção', path: 'cadastros/processos-selecao', modulo: 'PROCSEL', descricao: 'Cadastrar e configurar os processos de seleção', Icon: ListAltOutlined},
    {label: 'Programas', path: 'cadastros/programas', modulo: 'PROGRAMA', descricao: 'Manter os programas de bolsas da instituição', Icon: SchoolOutlined},
    {label: 'Enviar e-mails', path: 'recursos/envio-emails', modulo: 'RCENVEMAIL', descricao: 'Enviar e-mails aos inscritos dos processos', Icon: MailOutlined},
    {label: 'Termos de Concessão', path: 'relatorios/termos-concessao', modulo: 'RELCONCBOL', descricao: 'Gerar o Excel dos termos de concessão de bolsas', Icon: DescriptionOutlined}
];

const useStyles = makeStyles(theme => ({
    ...textButton(theme, false),
    containerPaper: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(3),
        minHeight: '100%'
    },
    boasVindas: {
        color: theme.palette.primary.main
    },
    divAtalhos: {
        justifyContent: 'center'
    },
    divAtalho: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        alignSelf: 'center',
        textAlign: 'center'
    },
    buttonAtalho: {
        minWidth: 200
    }
}));

export default function PageInicio() {
    const classes = useStyles();
    const navigate = useNavigate();
    const checkModule = useCheckModule();
    const initialPath = useInitialPath();

    const atalhosPermitidos = ATALHOS.filter(atalho => checkModule(atalho.modulo));

    return (
        <PageWrapper>
            <PageTitle title='Início'/>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper className={classes.containerPaper}>
                        <Typography variant='h6' gutterBottom className={classes.boasVindas}>
                            Bem-vindo(a) ao administrativo da Central de Bolsas
                        </Typography>
                        <Typography variant='body2'>
                            Use o menu acima para acessar as funcionalidades liberadas para o seu usuário.
                        </Typography>
                    </Paper>
                </Grid>
                {atalhosPermitidos.length > 0 && (
                    <Grid item xs={12}>
                        <Paper className={classes.containerPaper}>
                            <PageTitle title='Atalhos Rápidos'/>
                            <Grid container spacing={2} className={classes.divAtalhos}>
                                {atalhosPermitidos.map((atalho, index) => (
                                    <React.Fragment key={atalho.path}>
                                        {index > 0 && (index % 2 === 0
                                            ? <Separator noCenterText/>
                                            : <Separator noCenterText orientation='vertical'/>)}
                                        <Grid item xs={5} className={classes.divAtalho}>
                                            <Button
                                                variant='text'
                                                startIcon={<atalho.Icon/>}
                                                onClick={() => navigate(`/${initialPath}/${atalho.path}`)}
                                                className={clsx(classes.textButton, classes.buttonAtalho)}>
                                                {atalho.label}
                                            </Button>
                                            <Typography variant='body2'>{atalho.descricao}</Typography>
                                        </Grid>
                                    </React.Fragment>
                                ))}
                            </Grid>
                        </Paper>
                    </Grid>
                )}
            </Grid>
        </PageWrapper>
    );
}
